import { render, staticRenderFns } from "./ComprehensiveApproach.vue?vue&type=template&id=c0e68542&scoped=true"
import script from "./ComprehensiveApproach.vue?vue&type=script&lang=js"
export * from "./ComprehensiveApproach.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveApproach.vue?vue&type=style&index=0&id=c0e68542&prod&lang=scss"
import style1 from "./ComprehensiveApproach.vue?vue&type=style&index=1&id=c0e68542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e68542",
  null
  
)

export default component.exports